var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.55349863b3564aa206bd1143cd6290fc044ae987f9c9a18f59c79cc9f40605f0.svg#linkedin-no-fill';
                    var viewUrl = 'sprite.55349863b3564aa206bd1143cd6290fc044ae987f9c9a18f59c79cc9f40605f0.svg#view-linkedin-no-fill';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };